module.exports = __webpack_public_path__ + "producr-dried fresh-grass-07.jpg?df2d2e353e460a165bb322898953b92d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/producr-dried fresh-grass-07.jpg
// module id = 65
// module chunks = 0